import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import './checkbox.less';

export default class CheckBox extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    value: PropTypes.bool,
    defaultValue: PropTypes.bool,
    label: PropTypes.string,
    classNames: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);

    if (this.props.value !== undefined && this.props.defaultValue !== undefined) {
      console.error('[Checkbox] you cannot define both `value` and `defaultValue` props to the same component. `defaultValue` will be ignored.')
    }

    let checkedValue = false;
    if (this.props.defaultValue !== undefined) {
      checkedValue = !!this.props.defaultValue;
    }

    if (this.props.value !== undefined) {
      checkedValue = !!this.props.value;
    }

    this.state = {
      checked: checkedValue
    };

    this.value = checkedValue;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value !== undefined && nextProps.value !== this.state.checked) {
      this.value = nextProps.value;
      this.setState({ checked: nextProps.value });
    }
  }

  onClick(event) {
    if (this.props.onClick) return this.props.onClick(event);
    event.preventDefault();

    if (this.props.value !== undefined) {
      let checkedValue = !this.state.checked;
      this.value = checkedValue;
      this.setState({ value: checkedValue });
    }
  }

  render() {
    let classNames = [ 'checkbox-component' ];
    if (this.props.className) classNames.push(this.props.className);
    if (this.state.checked) classNames.push('checked');

    return (
      <div className={classNames.join(' ')} onClick={this.onClick}>
        <div className="box"><span className="inner-wrapper"><FontAwesome name="check" /></span></div>
        <div className="label">{this.props.label}</div>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./src/views/collection/checkbox.js
 **/